var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRedXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 35.5C69 54.5672 53.7644 70 35 70C16.2356 70 1 54.5672 1 35.5C1 16.4328 16.2356 1 35 1C53.7644 1 69 16.4328 69 35.5Z",
    fill: "#FF5858",
    stroke: "#FF5858",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6873 45.595L39.7107 35.587L49.6873 25.579C51.0757 24.1863 51.0757 21.9431 49.6874 20.5504C48.299 19.1577 46.0628 19.1577 44.6745 20.5504L34.6978 30.5584L24.7212 20.5504C23.3328 19.1577 21.0967 19.1577 19.7083 20.5504C18.3199 21.9432 18.3199 24.1863 19.7083 25.5791L29.6849 35.587L19.7083 45.595C18.3199 46.9877 18.3199 49.2309 19.7083 50.6236C21.0966 52.0163 23.3328 52.0163 24.7212 50.6236L34.6978 40.6156L44.6745 50.6236C46.0628 52.0163 48.299 52.0163 49.6873 50.6236C51.0757 49.2309 51.0757 46.9877 49.6873 45.595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedXIcon);
export default __webpack_public_path__ + "static/media/close-red-x-icon.1f1d3d1f26209d42c0d322f41eed9cdb.svg";
export { ForwardRef as ReactComponent };